module.exports = __webpack_public_path__ + "img/d10.f6bc08d8.jpg";